import { HttpAgent, HttpAgentOptions, Identity } from '@icp-sdk/core/agent'
import { AppConfig } from '../appConfig'
import { DEFAULT_LOCALHOST, IC_HOST } from '../constants/urls'
import { logger } from '../logger'
import { useDevMode } from '../state'

export const getAgentFactory = (
  getIdentity: (principalId: string) => Identity | Promise<Identity>,
  agentOptions?: HttpAgentOptions
): AppConfig['getAgent'] => {
  return ({ principalId, ...options } = {}) => {
    const { devEnabled, activeNetwork, networks } = useDevMode.getState()

    const network = activeNetwork ? networks[activeNetwork] : networks[Object.keys(networks)[0]]
    const host = options.host || devEnabled ? network?.hostUrl || DEFAULT_LOCALHOST : IC_HOST

    let identity
    if (principalId) {
      identity = getIdentity(principalId)
    }

    const agent = HttpAgent.createSync({
      identity,
      host,
      ...agentOptions,
      ...options,
    })

    if (devEnabled) {
      agent.fetchRootKey().catch(logger.debug)
    }

    return agent
  }
}
